import { render } from "./iFrame.vue?vue&type=template&id=09ed9262&scoped=true"
import script from "./iFrame.vue?vue&type=script&lang=js"
export * from "./iFrame.vue?vue&type=script&lang=js"

import "./iFrame.vue?vue&type=style&index=0&id=09ed9262&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ed9262"]])

export default __exports__